<template>
  <v-container fluid>
    <v-row>
      <v-col md="6" cols="12" class="not-found-text mb-3">
        <div class="not-found">
          <h1 style="color: black">404 - Страница не найдена</h1>
          <div class="not-found-info ma-5">
            <ul style="list-style-position: inside; padding: 0;">
              <li class="pb-3">Возможно, была допущена ошибка в ссылке</li>
              <li class="pb-3">А может страница была перемещена</li>
              <li class="pb-3">Или же её больше не существует</li>
            </ul>
          </div>
          <h4 class="mb-3">Лучшее решение - вернуться</h4>
          <v-btn
            v-if="roleName === 'master'"
            to="/"
            class="text-none mb-2"
            color="medium-emphasis"
            rounded
          >
            На главную
          </v-btn>
          <v-btn
            v-else
            to="/doorphones"
            class="text-none mb-2"
            color="medium-emphasis"
            rounded
          >
            К списку домофонов
          </v-btn>
        </div>
      </v-col>
      <v-col md="6" cols="12" class="not-found-img">
        <v-img :src="require('../../public/404.png')"></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NotFound',
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
  },
};
</script>

<style scoped>
.not-found {
  margin-top: 150px;
  text-align: center;
}
.not-found ul {
  margin: 0 auto;
  display: inline-block;
  text-align: center;
}
@media screen and (max-width: 1500px) {
  .not-found {
    margin-top: 130px;
  }
}
@media screen and (max-width: 1100px) {
  .not-found {
    margin-top: 20px;
  }
}
</style>
